import { Controller } from "@hotwired/stimulus"

// Simple tab switcher (plan show page: معرفی طرح / مدارک و مستندات / ...).
// Active state is driven by a `data-active` attribute so styling stays in
// Tailwind (`data-[active]:...` variants) rather than JS-managed class
// strings.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    if (window.location.hash) {
      const target = window.location.hash.slice(1)
      const tab = this.tabTargets.find((t) => t.dataset.tabName === target)
      if (tab) this.activate(target)
    }
  }

  select(event) {
    this.activate(event.currentTarget.dataset.tabName)
  }

  activate(name) {
    this.tabTargets.forEach((tab) => tab.toggleAttribute("data-active", tab.dataset.tabName === name))
    this.panelTargets.forEach((panel) => panel.classList.toggle("hidden", panel.dataset.tabName !== name))
  }
}
